import React, { createContext, useContext } from 'react';
import AxiosInstance from '../../server/AxioInstance';
import { saveAs } from 'file-saver';

const DownloadContext = createContext();

export const DownloadProvider = ({ children }) => {
  const handleDownload = async (data) => {
    try {
      const mimeType = getMimeType(data.type);
      const response = await AxiosInstance.get(`/document/${mimeType}/${data.filename}`, {
        responseType: 'blob',
      });
      const blob = new Blob([response.data]);
      saveAs(blob, data.originalname);
      console.log('Download do arquivo bem-sucedido!');
    } catch (error) {
      console.error('Erro ao fazer download do arquivo:', error);
      alert('Erro ao fazer o download do arquivo. Por favor, tente novamente mais tarde.');
    }
  };

  const getMimeType = (mimeType) => {
    switch (mimeType) {
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return 'docx';
      case 'application/pdf':
        return 'pdf';
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      case 'application/vnd.ms-powerpoint.presentation.macroenabled.12':
        return 'pptx';
      case 'text/csv':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return 'xlsx';
      default:
        return 'upload';
    }
  };

  const value = {
    handleDownload,
  };

  return <DownloadContext.Provider value={value}>{children}</DownloadContext.Provider>;
};

export const useDownload = () => {
  const context = useContext(DownloadContext);
  if (!context) {
    throw new Error('useDownload deve ser usado dentro de DownloadProvider');
  }
  return context;
};
